import React from 'react';
import { Link } from 'react-router-dom';

export const Button = ({ children, onClick, className = '', type = 'button' }) => {
  return (
    <button type={type} className={`btn-ghost ${className}`.trim()} onClick={onClick}>
      {children}
    </button>
  );
};

export const PrimaryButton = ({ children, to, className = '' }) => {
  if (to) {
    return (
      <Link className={`btn-primary ${className}`.trim()} to={to}>
        {children}
      </Link>
    );
  }

  return <button className={`btn-primary ${className}`.trim()}>{children}</button>;
};

export const FilterChip = ({ children, active, onClick }) => {
  return (
    <button
      className={`chip-filter ${active ? 'chip-filter-active' : ''}`.trim()}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
